import _ from 'lodash';

import { AllBlockTypes } from '../models/Content';
import {
    isTypeBanner,
    isTypeBlockArticles,
    isTypeBlockContent,
    isTypeBlockCta,
    isTypeBlockFaq,
    isTypeBlockLegalText,
    isTypeBlockProducts,
    isTypeBlockPromo,
    isTypeBlockQuickLink,
    isTypeBlockValuePrompt,
    isTypeLeadForm,
} from '../models/Generated';

export const getBlockId = (block: AllBlockTypes) => {
    if (
        isTypeBanner(block) ||
        isTypeBlockArticles(block) ||
        isTypeBlockContent(block) ||
        isTypeBlockCta(block) ||
        isTypeBlockFaq(block) ||
        isTypeBlockLegalText(block) ||
        isTypeBlockProducts(block) ||
        isTypeBlockPromo(block) ||
        isTypeBlockQuickLink(block) ||
        isTypeBlockValuePrompt(block)
    ) {
        return block.fields.title ? _.kebabCase(block.fields.title) : block.sys.id;
    }

    if (isTypeLeadForm(block)) {
        return block.fields.name ? _.kebabCase(block.fields.name) : block.sys.id;
    }

    return block.sys.id;
};
